// api should be here
import { http } from '@/utils/http';
import qs from 'qs';
// 活动api baseurl
const urlPrefix = 'vote/2023project/q3/2023qcjk/controller.php?enews=';

const getBaseInfo = () => {
  return http.get(`${urlPrefix}base-info`);
};

// 获取列表
const getList = (page: number, keyword?: string, workType?: number) => {
  return http.get(`${urlPrefix}vote-list`, {
    params: {
      page,
      search: keyword,
      workType,
    },
  });
};
// 规则
export const getRule = () => {
  return http.get(`${urlPrefix}rules`);
};

// 提交
export const save = (data: any) => {
  const qsData = qs.stringify(data);
  return http.post(`${urlPrefix}save`, qsData, { headers: {} });
};

// 详情
export const detail = (id: any) => {
  return http.get(`${urlPrefix}detail`, {
    params: {
      id,
    },
  });
};
// 获取列表
export const getUserList = (page: number, unionid?: any) => {
  return http.get(`${urlPrefix}vote-list-user`, {
    params: {
      page,
      unionid,
    },
    headers: {},
  });
};
const getNews = (page: any, category: any, classId: any) => {
  return http.get(
    `/v1/news/topicList?page=${page}&classId=${classId}&category=${category}`,
  );
};
export { getBaseInfo, getList, getNews };
